/**
 * Simplified Operational Checklists
 *
 * These are VERIFICATION checklists for qualified skippers.
 * Users are encouraged to customise for their vessel/company.
 *
 * Equipment inspections are handled by the Maintenance module.
 */

export { PRE_DEPARTURE_CHECKLIST } from './preDepartureChecklist';
export { TOWING_CHECKLIST } from './towingChecklist';
export { PERSONNEL_TRANSFER_CHECKLIST } from './personnelTransferChecklist';
export { BUNKERING_CHECKLIST } from './bunkeringChecklist';
export { ANCHORING_CHECKLIST } from './anchoringChecklist';
export { RESTRICTED_VISIBILITY_CHECKLIST } from './restrictedVisibilityChecklist';
export { HEAVY_WEATHER_CHECKLIST } from './heavyWeatherChecklist';
export { WATCH_HANDOVER_CHECKLIST } from './watchHandoverChecklist';
export { PRE_ARRIVAL_CHECKLIST } from './preArrivalChecklist';
export { ARRIVAL_CHECKLIST } from './arrivalChecklist';
export { PILOT_TRANSFER_CHECKLIST } from './pilotTransferChecklist';
export { CONFINED_WATERS_CHECKLIST } from './confinedWatersChecklist';
export { NIGHT_PASSAGE_CHECKLIST } from './nightPassageChecklist';
export { LIFTING_OPERATIONS_CHECKLIST } from './liftingOperationsChecklist';
export { HOT_WORK_CHECKLIST } from './hotWorkChecklist';
export { DIVING_SUPPORT_CHECKLIST } from './divingSupportChecklist';

// Icon imports for reference
import {
  Anchor,
  Link,
  Users,
  Fuel,
  Eye,
  CloudRain,
  RefreshCw,
  MapPin,
  Ship,
  UserPlus,
  Navigation,
  Moon,
  ArrowUpFromLine,
  Flame,
  Waves
} from 'lucide-react';

// Icon map for dynamic rendering
export const CHECKLIST_ICONS = {
  'Anchor': Anchor,
  'Link': Link,
  'Users': Users,
  'Fuel': Fuel,
  'Eye': Eye,
  'CloudRain': CloudRain,
  'RefreshCw': RefreshCw,
  'MapPin': MapPin,
  'Ship': Ship,
  'UserPlus': UserPlus,
  'Navigation': Navigation,
  'Moon': Moon,
  'ArrowUpFromLine': ArrowUpFromLine,
  'Flame': Flame,
  'Waves': Waves
};

// All simplified checklists in one object
import { PRE_DEPARTURE_CHECKLIST } from './preDepartureChecklist';
import { TOWING_CHECKLIST } from './towingChecklist';
import { PERSONNEL_TRANSFER_CHECKLIST } from './personnelTransferChecklist';
import { BUNKERING_CHECKLIST } from './bunkeringChecklist';
import { ANCHORING_CHECKLIST } from './anchoringChecklist';
import { RESTRICTED_VISIBILITY_CHECKLIST } from './restrictedVisibilityChecklist';
import { HEAVY_WEATHER_CHECKLIST } from './heavyWeatherChecklist';
import { WATCH_HANDOVER_CHECKLIST } from './watchHandoverChecklist';
import { PRE_ARRIVAL_CHECKLIST } from './preArrivalChecklist';
import { ARRIVAL_CHECKLIST } from './arrivalChecklist';
import { PILOT_TRANSFER_CHECKLIST } from './pilotTransferChecklist';
import { CONFINED_WATERS_CHECKLIST } from './confinedWatersChecklist';
import { NIGHT_PASSAGE_CHECKLIST } from './nightPassageChecklist';
import { LIFTING_OPERATIONS_CHECKLIST } from './liftingOperationsChecklist';
import { HOT_WORK_CHECKLIST } from './hotWorkChecklist';
import { DIVING_SUPPORT_CHECKLIST } from './divingSupportChecklist';

export const SIMPLIFIED_CHECKLISTS = {
  pre_departure: PRE_DEPARTURE_CHECKLIST,
  towing: TOWING_CHECKLIST,
  personnel_transfer: PERSONNEL_TRANSFER_CHECKLIST,
  bunkering: BUNKERING_CHECKLIST,
  anchoring: ANCHORING_CHECKLIST,
  restricted_visibility: RESTRICTED_VISIBILITY_CHECKLIST,
  heavy_weather: HEAVY_WEATHER_CHECKLIST,
  watch_handover: WATCH_HANDOVER_CHECKLIST,
  pre_arrival: PRE_ARRIVAL_CHECKLIST,
  arrival: ARRIVAL_CHECKLIST,
  pilot_transfer: PILOT_TRANSFER_CHECKLIST,
  confined_waters: CONFINED_WATERS_CHECKLIST,
  night_passage: NIGHT_PASSAGE_CHECKLIST,
  lifting_operations: LIFTING_OPERATIONS_CHECKLIST,
  hot_work: HOT_WORK_CHECKLIST,
  diving_support: DIVING_SUPPORT_CHECKLIST
};

export const CHECKLIST_IDS = Object.keys(SIMPLIFIED_CHECKLISTS);
